import { connectorsApi } from '@/features/connectors/api';
import type { Connector, Dataset } from '@/features/connectors/types';

export interface SourcesSummary {
  connectors: Connector[];
  datasets: Dataset[];
}

/**
 * The dashboard has no dedicated backend endpoint, so it composes the existing
 * surfaces: connectors + their datasets (for source/dataset/record counts and
 * the per-dataset bars). Anomalies and MDM clusters are pulled by the page via
 * their own hooks. Per-connector dataset calls are fanned out in parallel.
 */
export async function fetchSourcesSummary(): Promise<SourcesSummary> {
  const connectors = await connectorsApi.list();
  const nested = await Promise.all(
    connectors.map((c) => connectorsApi.datasets(c.id).catch(() => [] as Dataset[])),
  );
  return { connectors, datasets: nested.flat() };
}

export const dashboardKeys = {
  sources: ['dashboard', 'sources'] as const,
};
